import { render, staticRenderFns } from "./BaseElemDropdown.vue?vue&type=template&id=46a7da80&scoped=true&"
import script from "./BaseElemDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseElemDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseElemDropdown.vue?vue&type=style&index=0&id=46a7da80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a7da80",
  null
  
)

export default component.exports